import React from 'react';
import { Text } from '@chakra-ui/react';
import { ParagraphText } from './commonComponents';
import { TopPageVariant } from './types';

const HeaderContent = ({
  variant,
}: {
  variant: TopPageVariant;
}): JSX.Element => (
  <>
    {variant === 'normal' && (
      <>
        <Text
          backgroundColor="#193195"
          color="#ffe12e"
          fontSize={{ base: 'xl', md: '3xl' }}
          fontWeight="900"
          letterSpacing="wider"
          width="14em"
          maxW="90%"
          margin="auto"
        >
          学部卒で就職したい
        </Text>
        <Text
          as="h1"
          color="#19319C"
          fontSize="3xl"
          fontWeight="900"
          lineHeight="1.3"
          textAlign="center"
        >
          機電/情報/数物科学向け
          <br />
          オファー型就活サイト
        </Text>
        <ParagraphText py="15px" fontSize={{ base: 'xs', xs: 'sm', sm: 'lg' }}>
          理系で学部就職するならリケイマッチがおすすめ。
          <br />
          理系学部卒を歓迎する会社だけが利用しているから、
          <br />
          あなたを歓迎する会社からオファーが受け取れる。
        </ParagraphText>
      </>
    )}
    {variant === 'intern' && (
      <>
        <Text
          as="h1"
          color="#ffe12e"
          fontSize={{ base: '2xl', xs: '3xl', sm: '4xl' }}
          fontWeight="900"
          lineHeight="1.3"
          textAlign="center"
          py="20px"
        >
          学部卒の理系就活に特化
        </Text>
        <ParagraphText
          py="15px"
          fontSize={{ base: 'md', xs: 'xl' }}
          color="white"
        >
          企業からインターンのスカウトが届く
          <br />
          逆求人型就活サイト「リケイマッチ」
        </ParagraphText>
      </>
    )}
    {variant === 'interview' && (
      <>
        <Text
          backgroundColor="#193195"
          color="#ffe12e"
          fontSize={{ base: 'xl', md: '3xl' }}
          fontWeight="900"
          letterSpacing="wider"
          width="14em"
          maxW="90%"
          margin="auto"
        >
          就活中の理系学部生必見
        </Text>
        <Text
          as="h1"
          color="#19319C"
          fontSize="3xl"
          fontWeight="900"
          lineHeight="1.3"
          textAlign="center"
        >
          採用担当とカジュアルに面談できる
          <br />
          オファー型就活サイト
        </Text>
        <ParagraphText py="15px" fontSize={{ base: 'xs', xs: 'sm', sm: 'lg' }}>
          説明会のように大人数の場所では質問できない
          <br />
          そんな方におススメなのが「リケイマッチ」
          <br />
          理系学部卒歓迎の会社とカジュアルに面談可能
        </ParagraphText>
      </>
    )}
  </>
);

export default HeaderContent;
